/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListTemporaryGrantsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListTemporaryGrantsRequest = {
  /**
   * The principal whose grants to list, e.g. user:<id>, role:organization:<id> or agent:<id>. Members who are not organization administrators may only pass their own user URN.
   */
  principalUrn: string;
  /**
   * Include grants whose deadline has passed.
   */
  includeExpired?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListTemporaryGrantsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListTemporaryGrantsSecurity$outboundSchema: z.ZodMiniType<
  ListTemporaryGrantsSecurity$Outbound,
  ListTemporaryGrantsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listTemporaryGrantsSecurityToJSON(
  listTemporaryGrantsSecurity: ListTemporaryGrantsSecurity,
): string {
  return JSON.stringify(
    ListTemporaryGrantsSecurity$outboundSchema.parse(
      listTemporaryGrantsSecurity,
    ),
  );
}

/** @internal */
export type ListTemporaryGrantsRequest$Outbound = {
  principal_urn: string;
  include_expired: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListTemporaryGrantsRequest$outboundSchema: z.ZodMiniType<
  ListTemporaryGrantsRequest$Outbound,
  ListTemporaryGrantsRequest
> = z.pipe(
  z.object({
    principalUrn: z.string(),
    includeExpired: z._default(z.boolean(), false),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalUrn: "principal_urn",
      includeExpired: "include_expired",
      gramSession: "Gram-Session",
    });
  }),
);

export function listTemporaryGrantsRequestToJSON(
  listTemporaryGrantsRequest: ListTemporaryGrantsRequest,
): string {
  return JSON.stringify(
    ListTemporaryGrantsRequest$outboundSchema.parse(listTemporaryGrantsRequest),
  );
}
